
import { defineComponent, ref, watch, nextTick } from 'vue'
import { renderQrCode } from '@/utils/qrcode'
import { getStarActivationQrUrl } from '@/utils/useStarActivation'

const benefits = [
  '查看回测的模拟持仓和交易明细',
  '策略回测',
  '保存策略',
  '订阅策略信号',
  '解锁星投专属策略',
]

export default defineComponent({
  name: 'StarActivationDialog',
  props: {
    visible: { type: Boolean, default: false },
    showQr: { type: Boolean, default: false },
  },
  emits: ['activate', 'refresh', 'close'],
  setup(props) {
    const qrRef = ref<HTMLElement | null>(null)

    watch(
      () => props.showQr,
      async (val) => {
        if (!val) return
        await nextTick()
        if (qrRef.value) renderQrCode(qrRef.value, getStarActivationQrUrl(), 120)
      }
    )

    return { benefits, qrRef }
  },
})
